<template>
  <div style="min-height: 600px;">
    <v-card flat rounded="md" class="mb-15">
      <v-overlay absolute color="grey lighten-4" v-if="isLoading" opacity="1" style="height: 600px;">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      </v-overlay>
      <v-row v-if="enableTab && customer && !isLoading">
        <v-col cols="3">
          <v-card class="mt-3">
            <v-carousel height="auto">
              <template v-for="(item, i) in customer.profileImages">
                <a target="_blank" :href="item.url">
                  <v-carousel-item v-if="$helper.isImage(item.name)" :src="item.url || 'https://cdn-icons-png.flaticon.com/512/456/456212.png'"
                    reverse-transition="fade-transition" transition="fade-transition"></v-carousel-item>
                  <v-carousel-item v-else reverse-transition="fade-transition" transition="fade-transition">
                    <div style="height: 320px;" class="file-box">
                      <div>
                        {{ item.name }}
                      </div>
                    </div>
                  </v-carousel-item>
                </a>
              </template>
            </v-carousel>
          </v-card>
          <v-card class="mt-2" v-if="customer.type == 'personal'">
            <v-carousel height="auto">
              <a target="_blank" :href="item.url ? item.url : '#'" v-for="(item, i) in customer.citizenCardImages"
                :key="i">
                <v-carousel-item v-if="$helper.isImage(item.name)" :src="item.url ? item.url : '#'" reverse-transition="fade-transition"
                  transition="fade-transition"></v-carousel-item>
                <v-carousel-item v-else reverse-transition="fade-transition" transition="fade-transition">
                  <div style="height: 230px;" class="file-box">
                    <div>
                      {{ item.name }}
                    </div>
                  </div>
                </v-carousel-item>
              </a>
            </v-carousel>
            <div class="p-3 my-3 bg-white rounded">
              <span class="text-gray-400">{{ $t('account.issue_date_card') }} :</span>
              {{
                customer.citizenCardIssueDate
                ? $moment(customer.citizenCardIssueDate).format(
                  "D MMMM YYYY"
                )
                : "-"
              }}
              <br />
              <span class="text-gray-400">{{ $t('expiry_date') }} :</span>
              {{
                customer.citizenCardExpiryDate
                ? $moment(customer.citizenCardExpiryDate).format(
                  "D MMMM YYYY"
                )
                : "-"
              }}
            </div>
          </v-card>
          <div v-else class="my-5">
            <h3>
              <v-icon left>mdi-file-pdf-box</v-icon>{{ $t('market.company_document_file') }}
            </h3>
            <div class="p-3 my-2 bg-white rounded shadow" :key="i" v-for="(item, i) in customer.citizenCardImages">
              <a :href="item ? (item.url ? item.url : '#') : '#'" target="_blank" class="flex justify-between">
                {{ $t('file') }} {{ i + 1 }}
                <v-icon right>mdi-link-variant</v-icon>
              </a>
            </div>
          </div>
        </v-col>
        <v-col cols="9">
          <div class="p-5 my-3 border rounded-tl-sm shadow-md rounded-xl">
            <v-card-title class="d-flex justify-space-between">
              <h3>
                <v-icon left color="primary">
                  {{
                    customer.type == "company" ? `mdi-domain` : `mdi-account`
                  }}
                </v-icon>
                {{
                  customer.type == "company" ? `${$t('customer.company_data')}` : `${$t('customer.personal_data')}`
                }}
              </h3>
              <v-btn color="warning" dark elevation="0" @click="getObjectUpdate">
                <v-icon dark left>mdi-pencil</v-icon>{{ $t('customer.edit_trader_data') }}
              </v-btn>
            </v-card-title>
            <div v-if="!customer.type" class="px-5 red--text">
              {{ $t('validate.customer_type_is_not_correct_please_go_to_edit_trader_data_and_save_again') }}
            </div>
            <template v-if="customer.type == 'personal'">
              <v-card-text class="1rem">
                <v-row>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('account.name_and_surname') }}:</span>
                        <span class="mb-3 title-label">{{ $t('account.nickname') }}:</span>
                        <span class="mb-3 title-label">{{ $t('account.nationality') }}:</span>
                        <span class="mb-3 title-label">{{ $t('account.religion') }}:</span>
                        <span class="mb-3 title-label">{{ $t('account.marital_status') }}:</span>
                        <span class="mb-3 title-label">{{ $t('account.citizen_id_label') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">
                          {{
                            `${customer.title} ${customer.firstName} ${customer.lastName}`
                          }}
                        </span>
                        <span class="mb-3">{{ customer.nickName || "-" }}</span>
                        <span class="mb-3">{{ customer.nationalityString || "-" }}</span>
                        <span class="mb-3">{{ customer.religionString || "-" }}</span>
                        <span class="mb-3">{{ customer.marriageStatusString || "-" }}</span>
                        <span class="mb-3">{{ customer.citizenId || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('account.gender') }}:</span>
                        <span class="mb-3 title-label">{{ $t('account.birthday') }}:</span>
                        <span class="mb-3 title-label">{{ $t('account.spouse') }}:</span>
                        <span class="mb-3 text-white">-</span>
                        <span class="mb-3 title-label">{{ $t('account.laser_id') }}:</span>
                        <span class="mb-3 title-label">{{ $t('account.passport_number') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">
                          {{ customer.gender == "m" ? $t('account.male') : customer.gender == "f" ? $t('account.female') : "-" }}
                        </span>
                        <span class="mb-3">
                          {{
                            customer.dateOfBirth
                            ? $moment(customer.dateOfBirth).format(
                              "D MMMM YYYY"
                            )
                            : "-"
                          }}
                        </span>
                        <span class="mb-3">{{ customer.marriageName || "-" }}</span>
                        <span class="mb-3 text-white">-</span>
                        <span class="mb-3">
                          {{
                            customer.citizenCardLaserNo
                            ? customer.citizenCardLaserNo.substring(0, 5) +
                            "********" || "-"
                            : "-"
                          }}
                        </span>
                        <span class="mb-3">{{ customer.passportId || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-title class="d-flex justify-space-between">
                <h3>
                  <v-icon left color="primary">mdi-phone</v-icon>{{ $t('account.contact_information') }}
                </h3>
              </v-card-title>
              <v-card-text class="1rem">
                <v-row>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('account.phone_number') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ $helper.telToString(customer.interTels, customer.tels, { separator: ", " }) }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('account.email') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ joinArray(customer.emails, ", ") || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-title class="d-flex justify-space-between">
                <h3>
                  <v-icon left color="primary">mdi-school</v-icon>{{ $t('customer.education_information') }}
                </h3>
              </v-card-title>
              <v-card-text class="1rem">
                <v-row>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('account.education_level') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.educateLevelString || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex"></div>
                      <div class="flex-col text-black d-flex"></div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-title class="d-flex justify-space-between">
                <h3>
                  <v-icon left color="primary">mdi-map-marker</v-icon>{{ $t('customer.address_on_card') }}
                </h3>
              </v-card-title>
              <v-card-text class="1rem">
                <v-row>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('project.address_line_one') }}:</span>
                        <span class="mb-3 title-label">{{ $t('address.sub_district_or_district') }}:</span>
                        <span class="mb-3 title-label">{{ $t('address.amphoe_or_zone') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.addressStreet || "-" }}</span>
                        <span class="mb-3">{{ customer.addressSubDistrict || "-" }}</span>
                        <span class="mb-3">{{ customer.addressDistrict || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('project.province') }}:</span>
                        <span class="mb-3 title-label">{{ $t('project.postal_code') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.addressProvince || "-" }}</span>
                        <span class="mb-3">{{ customer.addressZipcode || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-title class="d-flex justify-space-between">
                <h3>
                  <v-icon left color="primary">mdi-map-marker</v-icon>{{ $t('customer.address_on_house_registration') }}
                </h3>
              </v-card-title>
              <v-card-text class="1rem">
                <v-row>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('project.address_line_one') }}:</span>
                        <span class="mb-3 title-label">{{ $t('address.sub_district_or_district') }}:</span>
                        <span class="mb-3 title-label">{{ $t('address.amphoe_or_zone') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.addressHouseStreet || "-" }}</span>
                        <span class="mb-3">{{ customer.addressHouseSubDistrict || "-" }}</span>
                        <span class="mb-3">{{ customer.addressHouseDistrict || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('project.province') }}:</span>
                        <span class="mb-3 title-label">{{ $t('project.postal_code') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.addressHouseProvince || "-" }}</span>
                        <span class="mb-3">{{ customer.addressHouseZipcode || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-title class="d-flex justify-space-between">
                <h3>
                  <v-icon left color="primary">mdi-map-marker</v-icon>{{ $t('customer.address_can_contact') }}
                </h3>
              </v-card-title>
              <v-card-text class="1rem">
                <v-row>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('project.address_line_one') }}:</span>
                        <span class="mb-3 title-label">{{ $t('address.sub_district_or_district') }}:</span>
                        <span class="mb-3 title-label">{{ $t('address.amphoe_or_zone') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.addressContactStreet || "-" }}</span>
                        <span class="mb-3">{{ customer.addressContactSubDistrict || "-" }}</span>
                        <span class="mb-3">{{ customer.addressContactDistrict || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('project.province') }}:</span>
                        <span class="mb-3 title-label">{{ $t('project.postal_code') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.addressContactProvince || "-" }}</span>
                        <span class="mb-3">{{ customer.addressContactZipcode || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-title class="d-flex justify-space-between">
                <h3>
                  <v-icon left color="primary">mdi-phone</v-icon>{{ $t('customer.emergency_contact_data') }}
                </h3>
              </v-card-title>
              <v-card-text class="1rem">
                <v-row>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('market.contact_person') }}:</span>
                        <span class="mb-3 title-label">{{ $t('companion_party') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.emergencyContactName || "-" }}</span>
                        <span class="mb-3">{{ customer.emergencyContactRelation || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('account.phone_number') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.emergencyContactTel || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </template>

            <template v-if="customer.type == 'company'">
              <v-card-text class="1rem">
                <v-row>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('customer.company_name_title') }}:</span>
                        <span class="mb-3 title-label">{{ $t('address.company_branch') }}:</span>
                        <span class="mb-3 title-label">{{ $t('tax.tax_id_number_another_form') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.companyName || "-" }}</span>
                        <span class="mb-3">{{ customer.companyBranchName || "-" }}</span>
                        <span class="mb-3">{{ customer.citizenId || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('website') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.website || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-title class="d-flex justify-space-between">
                <h3>
                  <v-icon left color="primary">mdi-phone</v-icon>{{ $t('account.contact_information') }}
                </h3>
              </v-card-title>
              <v-card-text class="1rem">
                <v-row>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('account.phone_number') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ joinArray(customer.tels, ", ") }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('account.email') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ joinArray(customer.emails, ", ") || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-title class="d-flex justify-space-between">
                <h3>
                  <v-icon left color="primary">mdi-map-marker</v-icon>{{ $t('customer.company_address_data') }}
                </h3>
              </v-card-title>
              <v-card-text class="1rem">
                <v-row>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('project.address_line_one') }}:</span>
                        <span class="mb-3 title-label">{{ $t('address.sub_district_or_district') }}:</span>
                        <span class="mb-3 title-label">{{ $t('address.amphoe_or_zone') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.addressStreet || "-" }}</span>
                        <span class="mb-3">{{ customer.addressSubDistrict || "-" }}</span>
                        <span class="mb-3">{{ customer.addressDistrict || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('project.province') }}:</span>
                        <span class="mb-3 title-label">{{ $t('project.postal_code') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.addressProvince || "-" }}</span>
                        <span class="mb-3">{{ customer.addressZipcode || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-title class="d-flex justify-space-between">
                <h3>
                  <v-icon left color="primary">mdi-phone</v-icon>{{ $t('customer.main_contact') }}
                </h3>
              </v-card-title>
              <v-card-text class="1rem">
                <v-row>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('market.contact_person') }}:</span>
                        <span class="mb-3 title-label">{{ $t('companion_party') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.emergencyContactName || "-" }}</span>
                        <span class="mb-3">{{ customer.emergencyContactRelation || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-base d-flex">
                      <div class="flex-col mr-10 d-flex">
                        <span class="mb-3 title-label">{{ $t('account.phone_number') }}:</span>
                        <span class="mb-3 title-label">{{ $t('account.email') }}:</span>
                      </div>
                      <div class="flex-col text-black d-flex">
                        <span class="mb-3">{{ customer.emergencyContactTel || "-" }}</span>
                        <span class="mb-3">{{ customer.emergencyContactEmail || "-" }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </template>
            <v-card-title class="d-flex justify-space-between">
              <h3>
                <v-icon left color="primary">mdi-cash</v-icon>{{ $t('income.income_data') }}
              </h3>
            </v-card-title>
            <v-card-text class="1rem">
              <v-row>
                <v-col cols="6">
                  <div class="text-base d-flex">
                    <div class="flex-col mr-10 d-flex">
                      <span class="mb-3 title-label">{{ $t('market.business_start_year') }}:</span>
                      <span class="mb-3 title-label">{{ $t('market.business_start_year_with_market') }}:</span>
                    </div>
                    <div class="flex-col text-black d-flex">
                      <span class="mb-3">{{ customer.businessStartYear }}</span>
                      <span class="mb-3">{{ customer.rentalStartYear }}</span>
                    </div>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="text-base d-flex">
                    <div class="flex-col mr-10 d-flex">
                      <span class="mb-3 title-label">{{ $t('income.income_per_year') }}:</span>
                    </div>
                    <div class="flex-col text-black d-flex">
                      <span class="mb-3">{{ customer.incomePerYear || "-" }}</span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-title class="d-flex justify-space-between">
              <h3>
                <v-icon left color="primary">mdi-bank</v-icon>{{ $t('payment.bank_data') }}
              </h3>
            </v-card-title>
            <v-card-title class="d-flex justify-space-between">
              <h3>
                <v-icon left color="primary">mdi-monitor-share</v-icon>{{ $t('customer.social_media_data') }}
              </h3>
            </v-card-title>
            <v-card-text class="1rem">
              <v-row>
                <v-col cols="6">
                  <div class="text-base flex py-2">
                    <div style="min-width:140px;">
                      Facebook
                      <v-icon class="mx-2" style="color:#4267B2;">mdi-facebook</v-icon>:
                    </div>
                    <div style="overflow-wrap: anywhere; word-break: break-all;">{{ customer.facebook || '-' }}</div>
                  </div>
                  <div class="text-base flex py-2">
                    <div style="min-width:140px;">
                      Instagram
                      <v-icon class="mx-2" style="color:#8a3ab9;">mdi-instagram</v-icon>:
                    </div>
                    <div style="overflow-wrap: anywhere; word-break: break-all;">{{ customer.instagram || '-' }}</div>
                  </div>
                  <div class="text-base flex py-2">
                    <div style="min-width:140px;">
                      TikTok
                      <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"
                        class="mx-2 inline-block">
                        <path
                          d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" />
                      </svg>:
                    </div>
                    <div style="overflow-wrap: anywhere; word-break: break-all;">{{ customer.tiktok || '-' }}</div>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="text-base flex py-2">
                    <div style="min-width:140px;">
                      LINE
                      <img src="../assets/icons/line.svg" alt="line-icon" height="24" width="24"
                        class="mx-2 inline-block" />:
                    </div>
                    <div style="overflow-wrap: anywhere; word-break: break-all;">{{ customer.lineId || '-' }}</div>
                  </div>
                  <div class="text-base flex py-2">
                    <div style="min-width:140px;">
                      Youtube
                      <v-icon class="mx-2" style="color:#FF0000;">mdi-youtube</v-icon>:
                    </div>
                    <div style="overflow-wrap: anywhere; word-break: break-all;">{{ customer.youtube || '-' }}</div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text class="1rem">
              <v-row>
                <v-col cols="12">
                  <bank-card v-for="(bank, index) of customer.bankAccounts" :key="index" :bankCode="bank.bankCode"
                    :accountBranch="bank.accountBranch" :accountName="bank.accountName"
                    :accountNumber="bank.accountNumber"></bank-card>
                  <div class="p-3 bg-white rounded shadow" v-if="customer.bankAccounts
                    ? customer.bankAccounts.length < 1
                    : true
                    ">{{ $t('customer.no_bank_account_data_only') }}</div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-title class="d-flex justify-space-between">
              <h3>
                <v-icon left color="primary">mdi-account-multiple</v-icon>{{ $t('customer.companion_party_information') }}
              </h3>
            </v-card-title>
            <v-card-text class="px-10">
              <a :href="`/project/${projectId}/market/${marketId}/customer/${customer.objectId}/view?tabs=2`"
                target="_blank" rel="noopener noreferrer" class="text-xl underline">{{ $t('customer.see_companion_party_information') }}</a>
            </v-card-text>
          </div>
        </v-col>
      </v-row>
      <v-card-text class="text-center mt-10" v-else-if="enableTab && !customer && !isLoading">
        <v-icon size="80">mdi-alert-circle-outline</v-icon>
        <h3 class="mt-4">{{ $t('customer.no_trader_data') }}</h3>
      </v-card-text>
      <v-card-text class="text-center mt-10" v-else-if="!enableTab && !isLoading">
        <v-icon size="80">mdi-alert-circle-outline</v-icon>
        <h3 class="mt-4">{{ $t('validate.sorry_you_do_not_have_access_to_the_data') }}</h3>
      </v-card-text>
    </v-card>
    <form-customer v-model="updateCustomerDialog" :objectId="obj.objectId" event="edit"
      @onUpdated="emitOnload"></form-customer>
  </div>
</template>

<script>
import ImageDialog from "./ImageDialog";
import FormCustomer from "./FormCustomer.vue";
import { mapGetters } from "vuex";
import { Banking } from "../classes";
import BankCard from "./BankCard.vue";
export default {
  components: {
    ImageDialog,
    FormCustomer,
    BankCard
  },
  name: "ProfileDetail",
  created() {
    if (
      (this.admin && this.admin.objectId) ||
      (this.employee && this.employee.enableViewCustomers)
    ) {
      this.enableTab = true;
    }
  },
  computed: {
    ...mapGetters({
      customer: "customer/getCustomer"
    }),
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    }
  },
  data() {
    return {
      isLoading: false,
      enableTab: false,
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
      updateCustomerDialog: false,
      obj: {},
      imageDialog: false,
      imgTitle: "",
      imgUrl: ""
    };
  },
  props: {
    contract: {
      type: Object,
      default: null
    },
    contractId: {
      default: "",
      type: String
    }
  },
  watch: {
    contractId: {
      handler(value) {
        if (value) this.loadCustomer();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async loadCustomer() {
      try {
        this.isLoading = true;
        if (
          this.contract &&
          this.contract.customer &&
          this.contract.customer.objectId
        )
          await this.$store.dispatch("customer/getCustomer", {
            id: this.contract.customer.objectId
          });
        else if (
          this.customer &&
          !(
            this.contract &&
            this.contract.customer &&
            this.contract.customer.objectId
          )
        ) {
          //has customer
        } else
          this.$toast.show({
            content: "This contract has no customers.",
            color: "error"
          });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    emitOnload() {
      this.loadCustomer();
    },
    openImage(url, title = "") {
      this.imageDialog = true;
      this.imgUrl = url;
      this.imgTitle = title;
    },
    getBank(code) {
      return Banking.getBank(code);
    },
    nationality(code) {
      const nationality = require("../json/nationalities.json");
      return nationality?.find(r => r.id == code)?.title || "-";
    },
    getDate(isoDate) {
      try {
        return isoDate.split("T")[0];
      } catch (err) {
        return "2021/01/01";
      }
    },
    getObjectUpdate() {
      this.obj = this.customer;
      this.updateCustomerDialog = true;
    },
    joinArray(arr = [], joinString = ", ") {
      return arr?.join(joinString);
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-text {
  font-weight: 550;
  letter-spacing: 0.03rem;
}

span.titleStyle {
  margin-bottom: 1rem;
}

.title-label {
  min-width: 180px;
}

.file-box {
  height: 320px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  font-size: 18px;
  color: var(--v-info-base);
}
</style>
